import monitoringMessageBuffer from './MonitoringMessageBuffer';
import monitoringDataProcessor from './MonitoringDataProcessor';

class MonitoringIngestionScheduler {
  constructor() {
    this.processingIntervalMs = 500;
    this.processingInterval = null;
    this.isProcessing = false;
    this.lastProcessedSequence = 0;
  }

  start() {
    if (this.processingInterval) {
      return;
    }

    monitoringDataProcessor.initializeProcessing();

    this.process();
    this.processingInterval = setInterval(() => {
      this.process();
    }, this.processingIntervalMs);
  }

  stop() {
    if (this.processingInterval) {
      clearInterval(this.processingInterval);
      this.processingInterval = null;
    }

    this.isProcessing = false;
    this.lastProcessedSequence = 0;
  }

  process() {
    if (this.isProcessing) {
      return;
    }

    this.isProcessing = true;

    try {
      const recentMessageCount = monitoringMessageBuffer.getMessageCount();

      if (recentMessageCount === 0) {
        return;
      }

      const {
        messages,
        nextSequence
      } = monitoringMessageBuffer.getMessagesAfter(this.lastProcessedSequence);
      const now = Date.now();

      this.lastProcessedSequence = nextSequence;

      monitoringDataProcessor.lastProcessedSequence = nextSequence;

      monitoringDataProcessor.processBatch(messages, recentMessageCount, now);
    } catch (error) {
      console.error('MonitoringIngestionScheduler: Error processing monitoring batch:', error);
    } finally {
      this.isProcessing = false;
    }
  }

  getDebugInfo() {
    return {
      isRunning: !!this.processingInterval,
      processingIntervalMs: this.processingIntervalMs,
      isProcessing: this.isProcessing,
      lastProcessedSequence: this.lastProcessedSequence
    };
  }
}

const monitoringIngestionScheduler = new MonitoringIngestionScheduler();

export default monitoringIngestionScheduler;
